<header>
  <div class="container" *ngIf="isSRLoaded">
    <div class="logo" ifSettingFalse="Global_HeaderLogo_Xl_Enabled">
      <a
        [href]="resourceService.getPortalSetting('Global_Header_Logo_Url')?.Value"
        (click)="!!resourceService.getPortalSetting('Global_Header_Logo_Url')?.Value" gtmClick="Logo"
        [gtmLinkURL]="resourceService.getPortalSetting('Global_Header_Logo_Url')?.Value">
        <adp-image imageKey="Global_Header_Logo"></adp-image>
      </a>
    </div>
    <div class="logo-xl" ifSettingTrue="Global_HeaderLogo_Xl_Enabled">
      <a
        [href]="resourceService.getPortalSetting('Global_Header_Logo_Url')?.Value"
        (click)="!!resourceService.getPortalSetting('Global_Header_Logo_Url')?.Value" gtmClick="Logo"
        [gtmLinkURL]="resourceService.getPortalSetting('Global_Header_Logo_Url')?.Value">
        <adp-image imageKey="Global_Header_Logo"></adp-image>
      </a>
    </div>
    <nav *ngIf="isMainNavVisible" [sf-aria-label]="'Global_Nav_Aria_Label'">
      <ng-container
        *ngIf="
          (headerLoggedOutSettings && headerLoggedOutSettings.length && !isAuthenticated) ||
          (headerLoggedInSettings && headerLoggedInSettings.length && isAuthenticated) ||
          chooseLanguage
        ">
        <div class="menu d-lg-none" (click)="onToggleMenu()" [ngClass]="isOpen ? 'open' : ''">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </ng-container>
      <div *ngIf="!isAuthenticated" class="logged-out d-none d-lg-block">
        <ul class="links" *ngIf="headerLoggedOutSettings?.length; else noHeaders">
          <li class="header-route" *ngFor="let item of headerLoggedOutSettings">
            <ng-container *ngIf="item.LinkUrl.startsWith('^'); else languages">
              <button
                id="claimsSupportMenu"
                mat-flat-button
                [matMenuTriggerFor]="programMenu"
                (menuOpened)="isProgramMenuOpen = true"
                (menuClosed)="isProgramMenuOpen = false"
                [gtmClick]="item.Caption"
                [gtmLinkURL]="item.LinkUrl">
                <span style="font-size: 1rem !important; font-weight: 600 !important">{{ item.Caption }}</span>
                <mat-icon style="margin-left: 5px" [@openClose]="isProgramMenuOpen ? 'closed' : 'open'">expand_more</mat-icon>
              </button>
              <mat-menu #programMenu="matMenu">
                <ng-container>
                  <button
                    mat-menu-item
                    *ngFor="let childItem of programInfoLinks"
                    [gtmClick]="childItem.Caption"
                    [gtmLinkURL]="childItem.LinkUrl"
                    (click)="this.claimsButtonClick(childItem)">
                    {{ childItem.Caption }}
                  </button>
                </ng-container>
              </mat-menu>
            </ng-container>
            <ng-template #languages>
              <ng-container *ngIf="item.LinkUrl.startsWith('languages'); else httpBlock">
                <a [title]="chooseLanguageTitle" class="language-toggle" href="javascript:void(0);" (click)="toggleLanguage()" [gtmClick]="chooseLanguage">{{
                  chooseLanguage
                }}</a>
              </ng-container>
            </ng-template>
            <ng-template #httpBlock>
              <ng-container *ngIf="item.LinkUrl.startsWith('http'); else routerBlock">
                <a [href]="item.LinkUrl" [target]="item.OpenNewTab ? '_blank' : '_self'" routerLinkActive="active">{{ item.Caption }}</a>
              </ng-container>
            </ng-template>
            <ng-template #routerBlock>
              <ng-container *ngIf="chooseLanguage && !logoutHeaderHasLanguage">
                <a [title]="chooseLanguageTitle" class="language-toggle" href="javascript:void(0);" (click)="toggleLanguage()" [gtmClick]="chooseLanguage">{{
                  chooseLanguage
                }}</a>
              </ng-container>
              <ng-container *ngIf="item.LinkUrl.startsWith('/login'); else otherRoute">
                <a class="active" routerlinkactive="active" (click)="routeToLogin(item)" [gtmClick]="item.Caption" [gtmLinkURL]="item.LinkUrl">{{ item.Caption }}</a>
              </ng-container>
            </ng-template>
            <ng-template #otherRoute>
              <a [routerLink]="item.LinkUrl" [target]="!!item.OpenNewTab ? '_blank' : null" routerLinkActive="active" [gtmClick]="item.Caption" [gtmLinkURL]="item.LinkUrl">{{ item.Caption }}</a>
            </ng-template>
          </li>
        </ul>
        <ng-template #noHeaders>
          <ng-container *ngIf="chooseLanguage">
            <a
              [title]="chooseLanguageTitle"
              class="language-toggle language-noheaders"
              href="javascript:void(0);"
              (click)="toggleLanguage()"
              [gtmClick]="chooseLanguage"
              >{{ chooseLanguage }}</a
            >
          </ng-container>
        </ng-template>
      </div>
      <div *ngIf="isAuthenticated" class="logged-in d-none d-lg-block">
        <ul class="links" *ngIf="headerLoggedInSettings">
          <li class="header-route" *ngFor="let item of headerLoggedInSettings"
           [ngStyle]="{ 'margin-right': item.LinkUrl.endsWith('action_coverage') || item.LinkUrl.endsWith('action_claims_support') ? '10px' : '',
            'margin-left': item.LinkUrl.endsWith('action_coverage') || item.LinkUrl.endsWith('action_claims_support') ? '18px' : ''}">
            <!-- User Profile Menu has different template -->
            <ng-container *ngIf="item.LinkUrl !== 'action_profile' && !item.LinkUrl.endsWith('action_claims_support') && !item.LinkUrl.endsWith('action_coverage'); else profileBlock">
              <a
                #navLink
                id="{{ this.menuId(item.LinkUrl) }}"
                [routerLink]="item.LinkUrl"
                [target]="item.OpenNewTab === true ? '_blank' : null"
                routerLinkActive="active"
                *ngIf="this.checkRouteAvailability(item.LinkUrl)"
                (keydown.enter)="navLink.click()"
                [gtmClick]="item.Caption"
                [gtmLinkURL]="item.LinkUrl"
                [ngClass]="
                  isTechServicesInMenu && (item.LinkUrl.endsWith('devices') || item.LinkUrl.endsWith('services')) ? 'active-after' : ''
                ">
                {{ item.Caption }}
              </a>
            </ng-container>
            <ng-template #profileBlock>
              <ng-container *ngIf="item.LinkUrl === 'action_profile'; else claimsBlock">
                <ng-container *ngIf="chooseLanguage">
                  <a [title]="chooseLanguageTitle" class="language-toggle" href="javascript:void(0);" (click)="toggleLanguage()" [gtmClick]="chooseLanguage">{{
                    chooseLanguage
                  }}</a>
                </ng-container>
                <button
                  id="profileButton"
                  mat-flat-button
                  class="user"
                  [matMenuTriggerFor]="profileMenu"
                  style="cursor: pointer; flex-direction: row-reverse"
                  (menuOpened)="isProfileMenuOpen = true"
                  (menuClosed)="isProfileMenuOpen = false"
                  gtmClick="action_profile"
                  [gtmLinkURL]="item.LinkUrl">
                  <span class="circle">
                    <pgh-avatar *ngIf="userFullName" name="{{ userFullName }}" color="{{ userAvatarColor }}" size="40"></pgh-avatar>
                  </span>
                  <mat-icon [@openClose]="isProfileMenuOpen ? 'closed' : 'open'">expand_more</mat-icon>
                </button>
                <mat-menu #profileMenu="matMenu">
                  <ng-container *ngIf="!areLinksLoaded">
                    <button
                      mat-menu-item
                      *ngFor="let childItem of defaultProfileLinks"
                      [gtmClick]="childItem?.Caption"
                      [gtmLinkURL]="childItem.LinkUrl"
                      (click)="this.profileButtonClick(childItem)">
                      {{ childItem?.Caption }}
                    </button>
                  </ng-container>
                  <ng-container *ngIf="areLinksLoaded">
                    <div class="mat-profile-info">
                      <span class="circle">
                        <pgh-avatar *ngIf="userFullName" name="{{ userFullName }}" color="{{ userAvatarColor }}" size="40"></pgh-avatar>
                      </span>
                      <span class="user-given-name cls_mask">{{ userGivenName && item.Caption.replace('{name}', userGivenName) }}</span>
                    </div>
                    <button
                      mat-menu-item
                      *ngFor="let childItem of profileLinks"
                      [gtmClick]="childItem.Caption"
                      [gtmLinkURL]="childItem.LinkUrl"
                      (click)="this.profileButtonClick(childItem)">
                      {{ childItem.Caption }}
                    </button>
                  </ng-container>
                </mat-menu>
              </ng-container>
            </ng-template>
            <ng-template #claimsBlock>
              <ng-container *ngIf="item.LinkUrl === 'action_claims_support'; else coverageBlock">
                <button
                  id="claimsSupportMenu"
                  mat-flat-button
                  [matMenuTriggerFor]="claimsMenu"
                  (menuOpened)="isClaimsMenuOpen = true"
                  (menuClosed)="isClaimsMenuOpen = false"
                  [gtmClick]="item.Caption"
                  [ngClass]="isTechServicesInMenu ? 'button-active-after' : ''">
                  <span style="font-size: 1rem !important; font-weight: 600 !important">{{ item.Caption }}</span>
                  <mat-icon style="margin-left: 5px" [@openClose]="isClaimsMenuOpen ? 'closed' : 'open'">expand_more</mat-icon>
                </button>
                <mat-menu #claimsMenu="matMenu">
                  <ng-container *ngIf="!areClaimsLinksLoaded">
                    <button
                      mat-menu-item
                      *ngFor="let childItem of defaultClaimsLinks"
                      [gtmClick]="childItem.Caption"
                      [gtmLinkURL]="childItem.LinkUrl"
                      (click)="this.claimsButtonClick(childItem)">
                      {{ childItem?.Caption }}
                    </button>
                  </ng-container>
                  <ng-container *ngIf="areClaimsLinksLoaded">
                    <button
                      mat-menu-item
                      *ngFor="let childItem of claimsLinks"
                      [gtmClick]="childItem.Caption"
                      [gtmLinkURL]="childItem.LinkUrl"
                      (click)="this.claimsButtonClick(childItem)">
                      {{ childItem.Caption }}
                    </button>
                  </ng-container>
                </mat-menu>
              </ng-container>
            </ng-template>
            <ng-template #coverageBlock>
              <ng-container>
                <button
                  id="coverageMenu"
                  mat-flat-button
                  [matMenuTriggerFor]="coverageMenu"
                  (menuOpened)="isCoverageMenuOpen = true"
                  (menuClosed)="isCoverageMenuOpen = false"
                  [gtmClick]="item.Caption"
                  [ngClass]="isTechServicesInMenu ? 'button-active-after' : ''">
                  <span style="font-size: 1rem !important; font-weight: 600 !important">{{ item.Caption }}</span>
                  <mat-icon style="margin-left: 5px" [@openClose]="isCoverageMenuOpen ? 'closed' : 'open'">expand_more</mat-icon>
                </button>
                <mat-menu #coverageMenu="matMenu">
                  <ng-container *ngIf="!areCoverageLinksLoaded">
                    <button
                      mat-menu-item
                      *ngFor="let childItem of defaultCoverageLinks; let i = index"
                      [gtmClick]="childItem.Caption"
                      [gtmLinkURL]="childItem.LinkUrl"
                      [ngClass]="defaultCoverageLinks.length > 1 ? '' : 'noMenuLine'"
                      (click)="this.coverageButtonClick(childItem)">
                      {{ childItem?.Caption }}
                    </button>
                  </ng-container>
                  <ng-container *ngIf="areCoverageLinksLoaded">
                    <button
                      mat-menu-item
                      *ngFor="let childItem of coverageLinks"
                      [gtmClick]="childItem.Caption"
                      [gtmLinkURL]="childItem.LinkUrl"
                      [ngClass]="defaultCoverageLinks.length > 1 ? '' : 'noMenuLine'"
                      (click)="this.coverageButtonClick(childItem)">
                      {{ childItem.Caption }}
                    </button>
                  </ng-container>
                </mat-menu>
              </ng-container>
            </ng-template>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</header>
